import { render, staticRenderFns } from "./DcExtendedLegend.vue?vue&type=template&id=07587c83&scoped=true&"
import script from "./DcExtendedLegend.vue?vue&type=script&lang=js&"
export * from "./DcExtendedLegend.vue?vue&type=script&lang=js&"
import style0 from "./DcExtendedLegend.vue?vue&type=style&index=0&id=07587c83&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07587c83",
  null
  
)

export default component.exports